import events from "./events";

export const api = events;
